import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import {
  ButtonContent,
  type CommonButtonProps,
  createButtonClassNames,
  determineIcon,
} from "./common-button-resources";

type SimpleButtonProps = {
  text: string;
} & CommonButtonProps &
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

// This button is not used often -- it's for edge cases where we don't want to submit a form or link to another page
// ex. the "Add another debt" button on the debt payoff calculator
export function SimpleButton({
  chevron,
  className,
  color,
  iconRight,
  size,
  text,
  type,
  variant,
  ...rest
}: SimpleButtonProps) {
  const classNames = !className?.includes("button-new")
    ? createButtonClassNames({
        className,
        color,
        iconRight,
        size,
        variant,
      })
    : className;

  let icon = determineIcon({ chevron, iconRight });

  return (
    <button type={type || "button"} className={classNames} {...rest}>
      <ButtonContent icon={icon} text={text} />
    </button>
  );
}
